
<template>
    <component :is="Component" 
               v-if="Component != null"
               
               :Arguments="Arguments"
               
               :Enabled="FinalEnabled"
               :value="value"
               @input="OnInput"
               @change="OnChange"
               ></component>
 </template>

<script>
    import Utility from "@/Common/Utility";
    import TControlBase from "@/Common/TControlBase";
    import Vue from 'vue';
 
    export default {
        data() {
            return {
                Component: null,
                componentValue:null ,
                arg: null,
            }
        }
        ,
        props: ["Path", "Arguments", "Query", "Data", ...TControlBase.BaseProps],


        computed: {
        }
        ,

        methods: {

            OnInput(theValue) { 
                this.$emit("input", theValue);
            } ,

            OnChange(theValue) {
                this.$emit("change", theValue);
            },

            LoadComponent() {
                let normalizedUrl;
                let resolveHandler = null;
                let url;
                let urlPrefix;
                let postUrl = "";
                let virtualDirectory = "";
                let resultPromise = new Promise(
                    (resolve) => {
                        resolveHandler = resolve;
                    }
                );
                 

                url = this.Path;

                urlPrefix = Utility.GetUrlPrefix();
                normalizedUrl = Utility.NormalizeDialogUrl(url);

                 

                if (url.indexOf("/Dialogs/") > 0) {
                    postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Dialogs/", "");
                    postUrl = (postUrl + "").replace("@/Dialogs/", "");


                    import("/Src/Dialogs/" + postUrl).then(
                        (module) => {
 
                            this.Component = module.default;
                          
                        }
                    ).catch(
                        (ex) => {
                            throw (ex);
                        }
                    );
                }
                else if (url.indexOf("/Controls/") > 0) {
                    postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Controls/", "");
                    postUrl = (postUrl + "").replace("@/Controls/", "");


                    import("/Src/Controls/" + postUrl).then(
                        (module) => {
                            let frame = {};

  
                            this.Component = module.default;

                        }
                    ).catch(
                        (ex) => {
                            throw (ex);
                        }
                    );
                }
                else {
                    postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Backend/", "");
                    postUrl = (postUrl + "").replace("@/Backend/", "");

                    import("/Src/Backend/" + postUrl).then(
                        (module) => {
                            this.Component = module.default;

                            this.$forceUpdate();
                        }
                    ).catch(
                        (ex) => {
                            throw (ex);
                        }
                    );
                }
            } 
        },

        created() {
            TControlBase.call(this);

            if (this.Path != null) {
                this.LoadComponent();
            }
        },

        watch: {
            Path(newVal) {

                if (newVal != null) {
                    this.Path = newVal;
                     
                    this.LoadComponent();
                }


                
            }
        }


    }
</script>

<style>
</style>
